import { createContext, useContext } from 'react';
export const ProductMediaLightboxContext = createContext(null);
export const useProductMediaLightbox = () => {
    const context = useContext(ProductMediaLightboxContext);
    return context;
};
